import { render, staticRenderFns } from "./CheckoutSummary.vue?vue&type=template&id=0dfe834c&scoped=true&"
import script from "./CheckoutSummary.vue?vue&type=script&lang=js&"
export * from "./CheckoutSummary.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutSummary.vue?vue&type=style&index=0&id=0dfe834c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dfe834c",
  null
  
)

export default component.exports